import React from 'react';

interface JSONPrettyProps {
    json: any | null;
}

const JSONPretty: React.FC<JSONPrettyProps> = ({ json }) => {
    return (
        <pre className='text-xs'>{JSON.stringify(json, null, 2)}</pre>
    );
};

export default JSONPretty;